/* istanbul ignore file */
import React, { useContext } from "react";



import { useIntervalWhen } from "rooks";
import { LikesButton, LikesButtonProps } from "./LikesButton";
import { PostConfigData, PostElementConfigData, ElementRotate, PostLayout, PostPanelConfigData, VotesConfigData, MessageConfigData, ChatConfigData } from "../Shared/Party/PartyConfigData";
import { Carousel, CarouselProps, ScrollFunction } from "./Carousel";
import { LiveMessageFeed, LiveMessageFeedProps } from "./LiveMessageFeed";
import { UIConfigContext } from "./UIConfigContext";
import { StateManagerContext } from "./StateManagerContext";
import { ActionButton, ActionHandler, CreateAction, EmptyActionData, IdActionData } from "./ActionButton";
import { FanboxStyling } from "./CSSUtilities";


//import { MessageDisplayProps, MessageConfigProps, Message } from "./Message";




export type PostDisplayProps = {
  postHeight: number;
  messageHeight: number;
  //selected?: string;
  userId: string;
  nonEditable?: boolean;
};


const calcFontBase = (width: number, height: number, fontBase: number, text: string, measureContext: React.MutableRefObject<CanvasRenderingContext2D | null>): number => {
  if (measureContext.current !== null) {
    measureContext.current.font = "regular " + fontBase + "px Roboto";
    const area = fontBase * measureContext.current.measureText(text ?? "").width;
    //console.log("Post Text Render: "  + (element.text?? ""));
    //console.log("Post Text Area @ " + fontBase + "px : " + area);
    const displayArea = width * height;
    const usage = area / displayArea;
    //console.log("Post Text Used Area: " + (usage * 100.0) + "% of " + displayArea);
    const useFontbase = Math.floor(0.5 * fontBase / Math.pow(usage, 0.5));
    //console.log("Suggested fontbase: " + useFontbase + "px");
    return useFontbase;
  }
  else
    return fontBase;
}

export type PostProps = {
  config: PostConfigData;
  display: PostDisplayProps;
};

type PanelPosition = 'left' | 'right' | 'only';

type PostPanelDisplayProps = {
  width: number;
  height: number;
  fontSize: number;
  measureContext: React.MutableRefObject<CanvasRenderingContext2D | null>;
  position: PanelPosition,
  voting?: VotesConfigData,
  title?: string,
  showOptional(id: string): void;
}




const PostPanel = ({ config, display }: { config: PostPanelConfigData, display: PostPanelDisplayProps }) => {

  const uiConfig = useContext(UIConfigContext);

  const hasButton = config.buttonText !== undefined || display.voting !== undefined;
  const buttonWidth = (display.width - 0.08 * display.height);
  const buttonHeight = (0.17 * display.height);
  const buttonMarginTop = (0.08 * display.height);
  const buttonColor = config.buttonColor === undefined ? 'darkPink' : config.buttonColor;
  const buttonTextColor = config.buttonTextColor === undefined ? 'white' : config.buttonTextColor;

  const optionalCall = config.buttonClick === undefined ? false : config.buttonClick.slice(0, 4) === 'opt:';
  const optionalId = (optionalCall && config.buttonClick !== undefined) ? config.buttonClick.slice(4) : undefined;

  if(hasButton) {
    console.log('post rendered with button; optionalCall = ' + optionalCall);
  }

  const availableHeight = hasButton ? (0.66 * display.height) : display.height;

  const imageElement = config.imageSrc !== undefined ?
    (<div style={{ backgroundImage: 'url(' + config.imageSrc + ')', height: availableHeight + "px", width: display.width + "px", border: "1px", borderColor: "red", backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: 'center' }} ></div>)
    : undefined;



  var textfontSize = display.measureContext !== null ? calcFontBase(display.width, availableHeight - (hasButton ? (buttonHeight + 2 * buttonMarginTop) : 0), display.fontSize, config.text ?? "Test", display.measureContext) : display.fontSize; //display.fontSize < 0 ? (display.measureContext !== null ? calcFontBase(display.width, availableHeight - (hasButton ? (buttonHeight + 2 * buttonMarginTop) : 0), -display.fontSize, config.text ?? "Test", display.measureContext) : -display.fontSize) : display.fontSize;
  const fs = uiConfig.textLayout.getFontSizeForHeight(display.width, availableHeight -  (hasButton ? (buttonHeight + 2 * buttonMarginTop):0), config.text ?? "Test");
  textfontSize = fs === 0 ? 14 : (fs> 36 ? 36 : fs);
  
  const styling : FanboxStyling = {
    width : buttonWidth,
    height : buttonHeight,
    color : {
      foreground : buttonTextColor,
      background : buttonColor
    },
    boundary : {
      margin : {
        quadType : 'margin',
        top : buttonMarginTop,
        bottom : 0,
        left : 0,
        right : 0,
      }
    },
    font : {
      size : display.fontSize,
      weight : 'regular'
    }
  }

  const handler : ActionHandler = (action) => {
    const id = action.get('id') ?? '';
    if(optionalCall)
        display.showOptional(id);
    return true;
  }

  const action = CreateAction('onClick', [], handler);
  const actionData = IdActionData(optionalId ?? '');

  return (<div
    style={{
      width: display.width + "px",
      maxWidth: display.width + "px",
      minWidth: display.width + "px",
      height: display.height + "px",
      maxHeight: display.height + "px",
      minHeight: display.height + "px",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: (config.text === undefined ? 'center' : 'left'),
      marginLeft: display.position === 'right' ? "5px" : "0px",
      marginRight: display.position === 'left' ? "5px" : "0px"


    }}
  >
    {
      (config.text !== undefined) && <span style={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: textfontSize, color: 'white' }}>{config.text}</span>
    }
    {
      (config.text === undefined && imageElement !== undefined && config.imageClick !== undefined) &&
      <a href={config.imageClick} target="_blank" rel="noreferrer">
        {imageElement}
      </a>
    }
    {
      (config.text === undefined && imageElement !== undefined && config.imageClick === undefined) &&
      imageElement
    }
    {
      (config.buttonText !== undefined) && (optionalCall ? (<ActionButton text={config.buttonText ?? ''}
        styling={styling}
        action={action}
        actionData={actionData}
        prompt={'left'}
        
         />) : (<a href={config.buttonClick} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
          <ActionButton text={config.buttonText ?? ''}
            styling={styling}
            action={action}
            actionData={actionData}
            prompt={'left'} />
        </a>))
    }
    {
      (display.voting !== undefined) && (<div style={{ marginTop: (0.08 * display.height) + 'px', display: 'flex', flexDirection: 'row', justifyContent: 'center', minWidth: display.width + 'px' }}><LikesButton unlike={false} voting={display.voting} width={0.65 * display.width} height={0.17 * display.height} background="#606060" fontBase={display.fontSize} radius={0.08 * display.height} text={display.title} padding={20} /></div>)
    }
  </div>)
}

type PostElementDisplayProps = {
  width: number;
  height: number;
  fontSize: number;
  measureContext: React.MutableRefObject<CanvasRenderingContext2D | null>;
  forceSingle: boolean,
  showOptional: (id: string) => void;
}

type PostElementProps = {
  config: PostElementConfigData,
  display: PostElementDisplayProps
}

const PostElement = ({ config, display }: PostElementProps): JSX.Element => {

  const votingPrimary = config.secondary !== undefined ? (config.secondary.text === undefined ? true : false) : true;
  const votingSecondary = config.secondary !== undefined ? (config.secondary.text === undefined ? false : true) : false;

  const panelWidth = (config.secondary === undefined || config.layout === 'primary-only') ? display.width - 20 : display.width * 0.5 - 15;
  const primaryPanelProps: PostPanelDisplayProps = {
    width: panelWidth,
    height: display.height,
    fontSize: display.fontSize,
    measureContext: display.measureContext,
    position: (config.secondary === undefined || config.layout === 'primary-only' || display.forceSingle) ? 'only' : (config.layout === 'primary-left' ? 'left' : 'right'),
    voting: votingPrimary ? config.voting : undefined,
    title: config.title,
    showOptional: display.showOptional,
  }

  const secondaryPanelProps: PostPanelDisplayProps = {
    width: panelWidth,
    height: display.height,
    fontSize: display.fontSize,
    measureContext: display.measureContext,
    position: config.layout === 'primary-left' ? 'right' : 'left',
    voting: votingSecondary ? config.voting : undefined,
    title: config.title,
    showOptional: display.showOptional,
  }

  return (<div
    style={{
      width: display.width + "px",
      maxWidth: display.width + "px",
      minWidth: display.width + "px",
      height: display.height + "px",
      maxHeight: display.height + "px",
      minHeight: display.height + "px",
      display: 'flex',
      flexDirection: (config.secondary === undefined || config.layout === 'primary-only' || display.forceSingle) ? 'column' : (config.layout === 'primary-left' ? 'row' : 'row-reverse'),
      margin: '10px'
    }}
  >
    <PostPanel config={config.primary} display={primaryPanelProps} />
    {
      (config.secondary !== undefined && config.layout !== 'primary-only' && !display.forceSingle) && <PostPanel config={config.secondary} display={secondaryPanelProps} />
    }
  </div>)

}


type ButtonPanelProps = {
  height: number;
  width: number;
  post: PostConfigData;
  keyIndex: string;

}

const ButtonPanel = ({ height, width, post, keyIndex }: ButtonPanelProps): React.JSX.Element => {

  const stateManager = React.useContext(StateManagerContext);
  const uiConfig = React.useContext(UIConfigContext);

  const voting = post.voting === undefined ? post.elements[post.elementIndex ?? 0].voting : post.voting
  //const votingState = post.voting !== undefined ? state.currentElement().voting() : state.voting();
  if (voting !== undefined) {

    let sx: Object = {
      maxHeight: height + "px",
      minHeight: height + "px",
      height: height + "px",
      maxWidth: (width * 0.5 - 20) + "px",
      width: (width * 0.5 - 20) + "px",
      marginLeft: "10px",
      marginRight: "10px",
      minWidth: width + "px",
    };

    const likesProps: LikesButtonProps = {
      width: (width * 0.5 - 20),
      height: height,
      matchExpression: false,
      voting: voting,
      background: 'black',
      radius: 10,
      fontBase: uiConfig.fontBase,
      unlike: false,
      likeStatus: (status: boolean) => { uiConfig.likeChange(voting.itemId, status); },
      format: 'row'

    }

    const commentClickHandler : ActionHandler = (_action) : boolean=> {
      //if (stateManager.user().cognito !== undefined) {
        const id = post.messageDisplay === 'element' ? post.elements[post.elementIndex ?? 0].chatId : post.chatId;
        uiConfig.showEventOverlay('reply', { id: id ?? '' });
        return true;
     /* }
      else {
        uiConfig.showEventOverlay('signIn', {});
      }*/

    }

    const commentAction = CreateAction('commentAction', [{permission : 'signedIn'}], commentClickHandler);

    const commentButtonStyling : FanboxStyling = {
      width : width * 0.5 - 20,
      height : height,
      color : {
        foreground : 'white',
        background : 'black'
      },
      boundary : {
        radius : 10,
      },
      font : {
        size : uiConfig.fontBase,
        weight : 'regular'
      }
    }


    return (
      <div style={{
        width: width + "px",
        minWidth: width + "px",
        maxWidth: width + "px",
        height: height + "px",
        minHeight: height + "px",
        maxHeight: height + "px",
        display: 'flex',
        flexDirection: 'row'
      }}
      >


        <div style={{ marginLeft: "10px", marginRight: "5px" }}>
          <LikesButton {...likesProps} key={keyIndex + "likesCounter"} />
        </div>
        <ActionButton action={commentAction} actionData={EmptyActionData} styling={commentButtonStyling} text="Add Comment" prompt={'left'}/>
        <div style={{ marginLeft: "10px", marginRight: "5px" }}>
         {/* <div style={{
            backgroundColor: 'black',
            borderRadius: '10px',
            width: (width * 0.5 - 20) + 'px',
            maxWidth: (width * 0.5 - 20) + 'px',
            minWidth: (width * 0.5 - 20) + 'px',
            height: height + 'px',
            minHeight: height + 'px',
            maxHeight: height + 'px',
          }}
            onClick={() => { commentClickHandler(); }}>
            <span style={{ fontSize: uiConfig.fontBase + 'px', color: 'white', fontFamily: 'Roboto', fontWeight: 400 }}
              onClick={() => { commentClickHandler(); }}>Add Comment</span>
          </div>*/}
        </div>
      </div>
    );
  }
  else
    return <div></div>
}

//const TITLE_HEIGHT = 2.0;
const BUTTON_HEIGHT = 2.0;



const selectToShow = (
  elements: PostElementConfigData[],
  indices: number[],
  layout: PostLayout,
  rotate: ElementRotate,
  imageIndex: number,
  tickCount: number,
): [PostElementConfigData, number][] => {
  const maxElements = layout === "double-element" ? 2 : 1;

  if (maxElements < elements.length) {
    if (rotate === 'pyramid') {

      const allImages = new Array<[PostElementConfigData, number]>();
      for (let i = 0; i < indices.length; i++) {
        allImages.push([elements[i], indices[i]]);
      }
      let displayImages = allImages.sort((a, b) => {
        return (a[0].voting?.likes ?? 0) - (b[0].voting?.likes ?? 0) //supportA - supportB;
      });

      const ns =
        elements.length - tickCount < maxElements ? maxElements : elements.length - tickCount;

      displayImages = displayImages.slice(0, ns);
      const ret = new Array<[PostElementConfigData, number]>();

      const index1 = Math.round(Math.random() * displayImages.length - 0.5);
      ret.push(displayImages[index1]);
      if (maxElements > 1) {
        displayImages.splice(index1, 1);
        const index2 = Math.round(Math.random() * displayImages.length - 0.5);
        ret.push(displayImages[index2]);
      }

      return ret;
    }
    else if (rotate === 'random') {
      const allImages = new Array<[PostElementConfigData, number]>();
      for (let i = 0; i < indices.length; i++) {
        allImages.push([elements[i], indices[i]]);
      }

      const ret = new Array<[PostElementConfigData, number]>();

      while (allImages.length > 0) {
        const index = Math.round(Math.random() * allImages.length - 0.5);
        ret.push(allImages[index]);
        allImages.splice(index, 1);
      }
      return ret;
    }
    else if (rotate === 'sequential' || rotate === 'carousel') {
      const allImages = new Array<[PostElementConfigData, number]>();
      for (let i = 0; i < indices.length; i++) {
        allImages.push([elements[i], indices[i]]);
      }
      return allImages;
    }
    else if (maxElements > 1) {
      return [
        [elements[imageIndex], indices[imageIndex]],
        [elements[imageIndex + 1], indices[imageIndex + 1]],
      ];
    }
    else {
      return [[elements[imageIndex], indices[imageIndex]]];
    }
  }
  else if (maxElements > 1) {
    return [
      [elements[imageIndex], indices[imageIndex]],
      [elements[imageIndex + 1], indices[imageIndex + 1]],
    ];
  }
  else {
    return [[elements[imageIndex], indices[imageIndex]]];
  }
};


export const Post = ({ config, display }: PostProps) => {
  const uiConfig = React.useContext(UIConfigContext);
  //const [messagIndex, setMessageIndex] = React.useState(0);
  const [tickCount, setTickCount] = React.useState(0);
  const measureContext = React.useRef(document.createElement("canvas").getContext("2d"));

  const elementList = React.useRef<[PostElementConfigData, number][]>([]);
  const postId = React.useRef<string>('');
  const carouselScrollRightFunction = React.useRef<ScrollFunction | null>(null);
  if (config.itemId !== postId.current) {
    elementList.current = [];
    postId.current = config.itemId;
  }

  if (elementList.current.length === 0) {
    const indices = new Array<number>();
    for (let i = 0; i < config.elements.length; i++) indices.push(i);
    elementList.current = config.elements.length > 0 ? selectToShow(
      config.elements,
      indices,
      config.layout,
      config.rotate,
      config.elementIndex ?? 0,
      tickCount
    ) : [];
  }



  const carouselCallback = (func: ScrollFunction) => {
    carouselScrollRightFunction.current = func;
  }




  const buttonHeight = BUTTON_HEIGHT * uiConfig.fontBase;
  const elementHeight = display.postHeight - 2 * uiConfig.fontBase - buttonHeight;
  const displayElements = elementList.current.length > 0 ? elementList.current.map((value, _index) => { return value[0]; }) : [];
  const displayTitle = displayElements.length > 0 ? (displayElements[0].title === undefined ? config.title : (displayElements[0].title ?? "")) : config.title;
  const author = config.author === undefined ?  'me' : config.author; 
  const titleMarkdown = (author[0] === "@" ? "" : "@") + author + " " + displayTitle;




  const maxElements = config.layout === 'single-element' ? 1 : 2;
  useIntervalWhen(
    () => {
      if ((config.rotate !== "carousel") && (config.elements.length > 2 || (config.elements.length > 1 && config.layout === "single-element"))) {
        setTickCount(tickCount + 1);
        //if (voteStart !== undefined) voteStart.current = 10 * tickCount;
        if (config.rotate === 'sequential') {
          const elementIndex = config.elementIndex ?? 0;
          const nx = elementIndex < config.elements.length - 1 ? elementIndex + 1 : 0;
          config.elementIndex = nx;
          if (carouselScrollRightFunction.current !== null)
            carouselScrollRightFunction.current();
        }
      }
    },
    10000,
    true,
  );

  const postElementDisplayProps: PostElementDisplayProps = {
    width: uiConfig.width / maxElements,
    height: elementHeight,
    fontSize: 20,
    measureContext: measureContext,
    forceSingle: maxElements > 1,
    showOptional: uiConfig.showOptional,

  }

  const carouselProps: CarouselProps = {
    display: maxElements,
    width: uiConfig.width,
    height: elementHeight,
    scrollButtonWidth: 0.1 * uiConfig.width,
    idPrefix: 'Post_' + config.itemId + '_Carousel',
    userControlled: config.rotate === 'carousel',
    scrollRight: carouselCallback,
    panels: displayElements.map((element: PostElementConfigData) => {
      return <PostElement config={element} display={postElementDisplayProps} />
    })
  }

  const buttonProps: ButtonPanelProps = {
    width: uiConfig.width,
    height: buttonHeight,
    post: config,
    keyIndex: "Post_" + config.itemId + "_Buttons_",
  }

  const chatId = config.messageDisplay === 'element' ? config.elements[config.elementIndex ?? 0].chatId : config.chatId;
  const showChat = config.messageDisplay !== 'none' && chatId !== undefined;

  const feedProps: LiveMessageFeedProps = {
    chatId: chatId ?? '',
    height: display.messageHeight,
    currentUser: display.userId,
  }

  const showNoElements = config.elements.length === 0;



  return (<div style={{
    width: uiConfig.width + "px",
    minWidth: uiConfig.width + "px",
    maxWidth: uiConfig.width + "px",
    height: (display.messageHeight + display.postHeight) + "px",
    minHeight: (display.messageHeight + display.postHeight) + "px",
    maxHeight: (display.messageHeight + display.postHeight) + "px",
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: uiConfig.contolBackground

  }}>
    <div style={{
      width: uiConfig.width + "px",
      minWidth: uiConfig.width + "px",
      maxWidth: uiConfig.width + "px",
      backgroundColor: "white",
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left'
    }}>
      <span style={{ fontSize: uiConfig.fontBase, textAlign: "left", paddingLeft: uiConfig.fontBase + "px", color: "black" }}>
        {titleMarkdown}
      </span>

    </div>
    <Carousel {...carouselProps} />


    {showNoElements && <div style={{
      width: uiConfig.width + "px",
      minWidth: uiConfig.width + "px",
      maxWidth: uiConfig.width + "px",
      backgroundColor: "white",
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left'
    }}>
      <span style={{ fontSize: uiConfig.fontBase * 2, textAlign: "left", paddingLeft: uiConfig.fontBase + "px", color: "white" }}>
        There are no posts to display.
      </span>
    </div>}
    {showChat && <LiveMessageFeed {...feedProps} key={config.itemId + 'lmf'} />}
    <ButtonPanel {...buttonProps} />


  </div>)








};

